// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__114Tv","buttons":"RemoveExpirationActionButtons_buttons__2H7WU"};